import { makeStyles, Popper } from '@material-ui/core'
import React from 'react'

import { Input } from '..'
import { PasswordConstraints } from './password-constraints'

export const PasswordInput = React.forwardRef(
    ({ validators, ...restProps }) => {
        const [anchorEl, setAnchorEl] = React.useState(null)
        const styles = useStyles()
        const handleFocus = event => {
            setAnchorEl(anchorEl ? null : event.currentTarget)
        }

        const handleBlur = event => {
            setAnchorEl(null)
        }

        const open = Boolean(anchorEl)
        return (
            <>
                <Popper
                    modifiers={{
                        flip: {
                            enabled: false
                        },
                        offset: {
                            enabled: true,
                            offset: '0,30'
                        }
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    placement={'top'}
                    className={styles.popper}
                >
                    <div className={styles.root}>
                        <PasswordConstraints validators={validators} />
                    </div>
                </Popper>
                <Input
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    type="password"
                    {...restProps}
                />
            </>
        )
    }
)

const useStyles = makeStyles(theme => ({
    root: {
        background: '#FFF',
        padding: 8,
        borderRadius: 4,
        boxShadow: theme.shadows[2]
    },
    popper: { zIndex: 2222 }
}))
